<script setup lang="ts">
import { computed } from "vue";

import { authStartup, retryAuthStartup } from "@/auth/startup";
import AppError from "@/components/AppError.vue";
import { presentError } from "@/lib/errors";

const presentedError = computed(() => presentError(authStartup.error.value));
</script>

<template>
  <div
    v-if="authStartup.status.value === 'loading' || authStartup.status.value === 'idle'"
    class="startup-screen"
  >
    <div class="brand-mark" aria-hidden="true">EA</div>
    <p class="eyebrow">EmpireAPI</p>
    <h1>Establishing authority context</h1>
    <div class="loading-line" aria-label="Loading"></div>
  </div>
  <div v-else-if="authStartup.status.value === 'error'" class="startup-screen">
    <div class="startup-card">
      <AppError :error="presentedError" action="Initialize authority console" />
      <button class="button primary" type="button" @click="retryAuthStartup">Try again</button>
    </div>
  </div>
  <RouterView v-else />
</template>
